<section *ngIf="pages.length">
    <h1>Select a module below to see a demo page</h1>
    <ul>
        <li *ngFor="let page of pages"><a [href]="page.route">{{ page.name }}</a></li>
    </ul>
</section>
